import React, { useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { getElementOnFocus, getElementToCopy } from '../../../store/global/selectors';
import { setElementToCopy, setExpanded, setReRender } from '../../../store/global/actions';
import errorConvertor from '../../../services/errorConvertor';
import { invokePostService, setInnerScreenRender } from '../../../store/global/actions'

const DeleteField = (props) => {
    const { id, onClose, onCompletion, element, messageId } = props
    const dispatch = useDispatch();

    const elementOnFocus = useSelector(getElementOnFocus);

    const [validationErrors, setValidationErrors] = useState([]);
    const [isForceDelete, setIsForceDelete] = useState(false);
    const [loading, setLoading] = useState(false);
    const copiedElement = useSelector(getElementToCopy);

    const onDelete = () => {
        setLoading(true);
        if (copiedElement?.id === id) {
            dispatch(setElementToCopy({}))
        }

        const payload = {isForceDelete}
        payload.rootParent = elementOnFocus.id;
        payload.rootParentType = elementOnFocus.type;
        if(messageId) payload.messageId = messageId;
        dispatch(invokePostService('deleteField', payload, [id])).then(res => {
            if (res?.status === true) {
                dispatch(setInnerScreenRender());
                onCompletion('Field', 'delete')
                if (res?.data?.deletedField !== undefined && res?.data?.deletedField?.parent !== undefined && res?.data?.deletedField?.parent[0]?.id !== undefined) dispatch(setExpanded(res?.data?.deletedField?.parent[0]?.id))

                dispatch(setReRender());
            } else {
                const errors = res?.data?.validationErrors ? res?.data?.validationErrors : [];
                if (errors.length > 0) {
                    const converter = new errorConvertor(errors);
                    converter.customConvert('The [item] is used in [feature] [featureEntity]');
                    setValidationErrors([...converter.sentences]);
                    setIsForceDelete(true)
                }
                if (res?.code === 255) {
                    onClose();
                }
            }
            setLoading(false);
        });
    }

    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12}>
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to delete Field {element?.name ? element?.name : ''} ? </Typography>
                {validationErrors.length > 0 && <Fragment>
                    <br />
                    <ol>
                        {validationErrors.map((item, index) =>
                            <li key={index}> {item.error} </li>
                        )}
                    </ol>
                </Fragment>}
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", textTransform: 'capitalize' }} >
                <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={loading} content={loading ? 'Deleting..' : isForceDelete ? 'Delete Anyway' : 'Delete'} />
            </Grid>


        </Grid>
    )
}

export default DeleteField;